import { Component } from '@angular/core';
import { AppState } from '../../../app.state';
import { Store } from '@ngrx/store';
import { DismissFlash } from '../store/flash.actions';

@Component({
  selector: 'flash-error',
  template: require('./flash-error.component.html'),
})
export class FlashErrorComponent {
  constructor(
    private store: Store<AppState>,
  ) {}

  dismiss() {
    this.store.dispatch(new DismissFlash());
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/flash/flash-error/flash-error.component.ts